module.exports = __webpack_public_path__ + "img/id-menu-sel-1.13d8cb2f.svg";